<template>
  <button
    type="button"
    class="bg-background-neutral-secondary relative w-full cursor-pointer rounded-2xl px-4 pb-4 pt-4 text-left"
    @click="emit('open', item)"
  >
    <FavoritesItemHeader :item="item" @remove="emit('remove', item)" />

    <section v-if="mappedFlights.length > 0" class="space-y-3 pb-1 pt-3">
      <div class="space-y-2">
        <SearchCardFlight
          v-for="(flight, idx) in mappedFlights"
          :key="idx"
          :offer-idx="0"
          :flight-idx="idx"
          :flight="flight"
        />
      </div>
    </section>
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import type { Dict } from '@aviata/platform-types';

  import { SearchCardFlight } from '@/widgets/search-result-card';

  import {
    type WatchlistItem,
    mapWatchlistOfferToMappedFlights,
  } from '@/features/favorites';

  import FavoritesItemHeader from './FavoritesItemHeader.vue';

  const props = defineProps<{
    item: WatchlistItem;
    dict?: Dict.Entity;
  }>();

  const emit = defineEmits<{
    remove: [item: WatchlistItem];
    open: [item: WatchlistItem];
  }>();

  const mappedFlights = computed(() =>
    mapWatchlistOfferToMappedFlights(props.dict, props.item.offer),
  );
</script>
